import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import CampaignDetails from './add';

const OutboundDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.outbound}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.outbound].addCampaignData]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/addCampaignData`}
				component={CampaignDetails}
				exact
			/>
			<Redirect to={`${path}/addCampaignData`} />
		</Switch>
	);
};

export default OutboundDashboard;
